export const GET_ACCOUNTTYPE_ABORTED = 'GET_ACCOUNTTYPE_ABORTED';
export const GET_ACCOUNTTYPE_REQUESTED = 'GET_ACCOUNTTYPE_REQUESTED';
export const GET_ACCOUNTTYPE_COMPLETED = 'GET_ACCOUNTTYPE_COMPLETED';
export const GET_ACCOUNTTYPE_FAILED = 'GET_ACCOUNTTYPE_FAILED';
export const RESET_ACCOUNTTYPE_REQUESTED = 'RESET_ACCOUNTTYPE_REQUESTED';
export const RESET_ACCOUNTTYPE_COMPLETED = 'RESET_ACCOUNTTYPE_COMPLETED';
